var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.86143 14.3835L1.33398 15.1673L2.11786 11.6398C1.61761 10.7044 1.33398 9.63565 1.33398 8.50065C1.33398 4.81875 4.31875 1.83398 8.00065 1.83398C11.6825 1.83398 14.6673 4.81875 14.6673 8.50065C14.6673 12.1825 11.6825 15.1673 8.00065 15.1673C6.86565 15.1673 5.79692 14.8837 4.86143 14.3835ZM5.05448 12.9747L5.49017 13.2077C6.25564 13.617 7.11098 13.834 8.00065 13.834C10.9462 13.834 13.334 11.4462 13.334 8.50065C13.334 5.55513 10.9462 3.16732 8.00065 3.16732C5.05513 3.16732 2.66732 5.55513 2.66732 8.50065C2.66732 9.39032 2.88431 10.2457 3.29364 11.0111L3.52662 11.4468L3.09009 13.4112L5.05448 12.9747Z",
    fill: "#95959B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconComment);
export default __webpack_public_path__ + "static/media/icon-comment.153d6f41ec2e70be1ee787ff1d43043b.svg";
export { ForwardRef as ReactComponent };